import React, { Component } from 'react';
import signature from '../images/signature.gif';
import complex_map_arrow from '../images/complex_map_arrow.png'
import {Link} from 'react-router-dom'


class Home extends Component {
    render() {
        return (
            <div>
                <div className="row my-4">
                    <div className="col text-center">
                        <Link to="/covid19"><h4>A Message To Our Patients About The Covid-19 Pandemic</h4></Link>
                    </div>
                </div>
                <div className="row">
                    <div className="col">
                            <strong><i>Dear Valued Patients,</i></strong>
                            <br /><br />
                            It is with sadness and great anticipation that I write you this letter. After 19 years at Commerce Plaza Hillcrest
                            and 39 years total in practice, I am moving. After months of rumors and speculation, HEB announced in
                            January it had bought the land on which our current practice sits and the office complex will be knocked down
                            in 2026.
                            <br /><br />
                            I have deliberately sought a solution that works for the both of us. I am very excited to let you know that
                            effective September 25th, I am joining the practice of Dr. Jordana Contrucci Ruiz (CR Dental Group) at
                            Medical City Dallas. Located only one mile away from our current office, Dr. Contrucci and her associates
                            share my same family-oriented culture and philosophy of getting to know you and your families first, while
                            also performing state of the art dentistry. I am excited to share new technologies and capabilities that the
                            CR Dental Group brings to your care.
                            <br /><br />
                            As many of you know, Tami and I have worked together for 31 years and she has now taken this opportunity
                            to enjoy a well-deserved retirement. I am excited to watch her enter this next chapter and all the adventures
                            waiting for her and Joe.
                            <br /><br />
                            My passion has been serving you and your family with the best dental care, while sharing in your many stories,
                            vacations, milestones, birthdays and anniversaries. I have been privileged to watch your families grow across
                            generations, and am beyond humbled to have served you for so many years. You are not only patients, I consider 
                            you friends and family. I look forward to seeing you in our new office and introducing you to the team.
                            <br /><br />
                            Please join us from 12 - 2 pm on September 19th for a meet and greet to see the new space, meet the CR Dental
                            Group, and wish Tami well.
                            <br /><br />
                            <strong>7777 Forest Lane<br />
                            Suite C-104<br />
                            Dallas, Texas<br />
                            972-299-0090</strong>
                            <br /><br />
                            I look forward to seeing you soon and continuing your dental care. For those that have seen me recently, I have
                            taken the liberty of passing on your next appointments and our new team will be confirming and/or rescheduling
                            you as needed. Feel free to reach out to me directly or to the CR Dental Group at 972-299-0090 with any questions and next steps. After September 24th my current phone number will transfer to the new Office.
                            <br /><br />
                            In your service and my very best to you,
                            <br /><br />
                            John S. Wiggans, DDS
                    </div>
                </div>
                <div className="row">
                    <div className="col text-center">
                        <img src={complex_map_arrow} alt="John S Wiggans, DDS, Dallas Texas Family and Cosmectic Dentistry" className="img-fluid" />
                    </div>
                </div>
            </div>
        )
    }
}

export default Home